import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n/i18n";

export const FullLoader = ({ label }) => {
  const { t } = useI18n();
  return (
    <div className="flex min-h-screen items-center justify-center gap-3 text-sm text-slate-500" data-testid="page-loader">
      <Loader2 className="h-5 w-5 animate-spin text-upv" /> {t(label || "Cargando…")}
    </div>
  );
};

/** Guards a route by role; company routes can also require an approved company. */
export const RequireRole = ({ roles, needCompany = false, children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <FullLoader />;
  const next = encodeURIComponent(loc.pathname + loc.search);
  if (!user || !roles.includes(user.role)) return <Navigate to={`/login?next=${next}`} replace />;
  if (needCompany && user.role === "company" && !user.companyId) {
    return user.applicationId ? <Navigate to={`/empresas/inscripcion/${user.applicationId}`} replace /> : <Navigate to="/login" replace />;
  }
  return children;
};
